// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"SnoozeFooter_buttonGroup__wWkW1","buttonGroup_separator":"SnoozeFooter_buttonGroup_separator__MGHHC"};